<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายละเอียดส่งคืนสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-card class="mb-5" elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="setting">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลการคืนสินค้า</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-row>
                    <v-col cols="4">
                      <h3>วันที่ทำเรื่องคืน: {{ data_list.created_at }}</h3>
                    </v-col>
                    <v-col cols="6">
                      <h3>หมายเลขการคืน: {{ data_list.refund_code }}</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <h4>หมายเลขคำสั่งซื้อ: {{ data_list.order_code }}</h4>
                    </v-col>
                    <v-col cols="12">
                      <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="100" class="text-left">รายการสินค้า </th>
                          <th class="text-left"></th>
                          <th class="text-left">
                            ราคาต่อหน่วย
                          </th>
                          <th class="text-left">
                            จำนวน
                          </th>
                          <th class="text-left">
                            ราคารวม
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in data_list.refund_list" :key="item.id" >
                          <td>
                            <div class="my-2">
                              <v-img class="preview" height="80" width="80" lazy-src="@/assets/arin_assets/image_sun_color.png" :src="item.product_picture"></v-img>
                            </div>
                          </td>
                          <td>
                            <v-row>
                              <v-col class="text-center" cols="4">
                                <span>{{ item.name }}</span>
                              </v-col>
                              <v-col cols="8">
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <span>ล๊อต: {{ item.lot_no }} วันหมดอายุ: {{ item.date_expired }}</span>
                              </v-col>
                            </v-row>
                          </td>
                          <td>{{ item.cost }}</td>
                          <td>
                            {{ item.quantity }}
                          </td>
                          <td>{{ item.total }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-5"  elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="setting">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">สาเหตุการคืน</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <h3 v-if="data_list.refund_reason == 1">สาเหตุการคืน: ของมาผิด</h3>
                  <h3 v-if="data_list.refund_reason == 2">สาเหตุการคืน: ชำรุด</h3>
                  <h3 v-if="data_list.refund_reason == 3">สาเหตุการคืน: อื่นๆ</h3>
                </v-col>
                <v-col  cols="12 pt-0">
                  <label class="label_form_text pb-4"> รูปภาพสินค้าที่ต้องการส่งคืน </label> 
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12" class="pt-0">
                  <v-form-group class="line-grid">
                    <label for="">ภาพสินค้าบริเวร เลขล๊อตและวันหมดอายุ</label>
                    <v-img v-if="data_list.picture_lot !== null" :lazy-src="img_holder_cert" :src="data_list.picture_lot"
                      class="preview profile_img"></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="data_list.picture_lot" class="preview profile_img"></v-img>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12" class="pt-0">
                  <v-form-group class="line-grid">
                    <label for="">ภาพความผิดปกติปกติของสินค้า</label>
                    <v-img v-if="data_list.picture_damage !== null" :lazy-src="img_holder_cert" :src="data_list.picture_damage"
                      class="preview profile_img"></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="data_list.picture_damage" class="preview profile_img"></v-img>
                  </v-form-group>
                </v-col>  
              </v-row>

              <v-row>
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <h3 v-if="data_list.refund_send == 1">การส่งคืนสินค้าฟาร์มาแคร์: ส่งคืนที่หน้าร้าน</h3>
                  <h3 v-if="data_list.refund_send == 2">การส่งคืนสินค้าฟาร์มาแคร์: ส่งพัสดุ</h3>
                </v-col>
              </v-row>
              <v-row>
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                  <h3 v-if="data_list.refund_fix == 2" >วิธีการแก้ไข: คืนเงิน</h3>
                  <h3 v-if="data_list.refund_fix == 1" >วิธีการแก้ไข: ส่งสินค้าใหม่</h3>
                </v-col>
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                  <h3 v-if="data_list.refund_send == 1">ชื่อบัญชี: {{ data_list.refund_fix_bank_account_name }}</h3>
                  <h3 v-if="data_list.refund_send == 2">ชื่อผู้รับ: {{ data_list.refund_fix_name }}</h3>
                </v-col>
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                  <h3 v-if="data_list.refund_send == 2">เบอร์โทร: {{ data_list.refund_fix_tel }}</h3>
                </v-col>
              </v-row>
              <v-row v-if="data_list.refund_send == 1">
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                </v-col>
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                  <h3>ธนาคาร: {{ data_list.refund_fix_bank_name }}</h3>
                </v-col>
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                  <h3>เลขที่บัญชี: {{ data_list.refund_fix_bank_number }}</h3>
                </v-col>
              </v-row>

              <v-row v-if="data_list.refund_send == 2">
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="4" sm="4" md="4" lg="4" xl="4" cols="4">
                </v-col>
                <v-col xs="8" sm="8" md="8" lg="8" xl="8" cols="8">
                  <h3>ที่อยู่: {{ data_list.refund_fix_address }} {{ data_list.refund_fix_sub_address }}</h3>
                </v-col>
              </v-row>
              
            </v-form>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-5" elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="setting">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">การตอบกลับจากฟาร์มาแคร์</div>
                    </div>
                  </div>
                </v-col>

                <v-col v-if="data_list.refund_status == 3" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-row>
                    <v-col cols="12">
                      <h3>คำร้องถูกปฏิเสธ</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <h3>เนื่องจาก ไม่อยู่ในเงื่อนไขในการรับเงิน: {{ data_list.refund_code }}</h3>
                    </v-col>
                    <v-col class="text-right" cols="6"><h3>{{ data_list.updated_at }}</h3></v-col>
                  </v-row>
                </v-col>

                <v-col v-if="data_list.refund_status == 1" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-row>
                    <v-col cols="12">
                      <h3><span>กรุณาส่งคืนสินค้าของท่านให้กับเรา</span> <span>กรุณาแจ้งหมายเลขการคืน: {{ data_list.refund_code }} </span></h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2">
                      <h3>ท่านสามารถส่งคืนสินค้าได้ที่</h3>
                    </v-col>
                    <v-col cols="10">
                      <h3>ฟาร์มาแคร์ พลัส (สำนักงานใหญ่)</h3>
                      <h3>ที่อยู่ 197/3-4 ถ.เชียงใหม่-หางดง ต.ป่าแดด อ.เมือง จ.เชียงใหม่ 50100</h3>
                      <h3>เบอร์โทร 053 272 123</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                    </v-col>
                    <v-col class="text-right" cols="6"><h3>{{ data_list.updated_at }}</h3></v-col>
                  </v-row>
                </v-col>

                <v-col v-if="data_list.refund_status == 2" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-row>
                    <v-col cols="12">
                      <h3>ได้รับของแล้ว รอดำเนินการแก้ไข</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <h3>ได้รับของแล้ว รอดำเนินการแก้ไข รอดำเนินการแก้ไข</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                    </v-col>
                    <v-col class="text-right" cols="6"><h3>{{ data_list.updated_at }}</h3></v-col>
                  </v-row>
                </v-col>

                <v-col v-if="data_list.refund_status == 4" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-row>
                    <v-col cols="12">
                      <h3>เราได้ดำเนินการตามคำร้องของท่านเรียบร้อยแล้ว</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <h3>เอกสารการโอนเงินคืน</h3>
                    </v-col>
                    <v-col cols="12">
                      <v-img v-if="imagePreviewURL !== null" :lazy-src="img_holder_cert" :src="data_list.slips"
                      class="preview profile_img"></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="img_holder_cert" class="preview profile_img"></v-img>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                    </v-col>
                    <v-col class="text-right" cols="6"><h3>{{ data_list.updated_at }}</h3></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>

  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_profile.png";
import img_holder_document from "@/assets/arin_assets/image_document.png";
import img_holder_cert from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
// import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Manage_website",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      imagePreviewURL: null,
      data_list: [
        {
          product_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
          price_unit: '฿ 35.00',
          qty: 1,
        },
        {
          product_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1200 ML. **ฝาฟ้า 55.-',
          price_unit: '฿ 45.00',
          qty: 1,
        },
        
      ],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'ออกใบสั่งซื้อ',
          disabled: false,
        },
        {
          text: 'คำสั่งซื้อของฉัน',
          disabled: false,
        },
        {
          text: 'รายละเอียดส่งคืนสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      order: [],
    }
  },
  methods: {
    retrunProductDetail() {
      let id = this.$route.query.id
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/refund/detail/'+ id, config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
          this.loading_page = false;
        }
      })
    }
  },
  mounted() {
    this.retrunProductDetail();
  }
}
</script>

<style scoped>

.pa-40
{
  padding: 40px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.line-grid{
  display: inline-grid;
}
.font-20
{
  font-size: 20px;
}
.title-flex-center
{
  display: flex;
  align-items: center;
}

.title-flex-baseline
{
  display: flex;
  align-items: baseline;
  font-size: 16px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #D6BFAF;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #D6BFAF;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;

}

.title_form_header_text {
  color: #616A6B;
}


.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}



.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;
  
}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}
</style>
